import styled from 'styled-components'
import {
  communicationButtonCss,
  communicationContentWrapperCss,
  communicationRootCss,
  communicationTitleCss,
} from '~/pages/communication/libs/communicationBaseStyles'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  Root: styled.div`
    ${communicationRootCss}
    background-color: ${COLORS.GRAY_100};
  `,

  StyledContainer: styled(Container)`
    padding: 24px 16px;
    height: 100%;
    overflow-y: auto;
    ${communicationContentWrapperCss}
  `,

  Title: styled.h1`
    ${communicationTitleCss}
    text-align: left;
    margin-bottom: 24px;
  `,

  ProgressContainer: styled.div`
    margin-bottom: 32px;
  `,

  EnjoyTitle: styled.h2`
    font-family: 'Mulish', sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    color: ${COLORS.BLACK};
    margin-bottom: 24px;
  `,

  Review: styled.div`
    padding: 12px;
    background: ${COLORS.WHITE};
    box-shadow: 0px 4px 10px 0px rgba(9, 110, 249, 0.1);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,

  ReviewHeader: styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
  `,

  ReviewAvatar: styled.img`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
  `,

  ReviewNameBlock: styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
  `,

  ReviewAuthor: styled.p`
    font-family: 'Mulish', sans-serif;
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    color: ${COLORS.BLACK};
  `,

  ReviewStars: styled.img`
    height: 20px;
    width: auto;
  `,

  ReviewText: styled.p`
    font-family: 'Mulish', sans-serif;
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.BLACK_ALPHA_50};
  `,

  Overlay: styled.div`
    position: fixed;
    inset: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
  `,

  PopupCard: styled.div`
    background: ${COLORS.WHITE};
    border-radius: 24px;
    padding: 24px 16px 16px;
    width: 100%;
    max-width: 400px;
    box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.16);
    display: flex;
    flex-direction: column;
    gap: 20px;
  `,

  PopupQuestion: styled.h2`
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    color: #17202a;
    text-align: center;
  `,

  PopupButtonWrapper: styled.div`
    display: flex;
    gap: 8px;
  `,

  PopupButtonNo: styled.button`
    flex: 1;
    padding: 14px 8px;
    border: none;
    border-radius: 14px;
    background: #82b6fe;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.2;
    color: ${COLORS.WHITE};
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    touch-action: manipulation;
  `,

  PopupButtonYes: styled.button`
    ${communicationButtonCss}
    flex: 1;
    padding: 14px 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.2;
  `,
} as const
